import { Dropdown, Popover } from "antd";
import useQueueStore from "../../../stores/queue-store";
import { RequestedAppointmentInfoUi } from "ui";
import { Appointment } from "@elixir/types";
import LeftPanelCard from "../../../molecules/cards/queue/left-panel-card";
import { QUEUE_TYPE } from "../../../constants/appointments";
import { XMarkRegularIcon } from "@elixir/icons";
import useAllQueuesQuery from "../../../apis/tryst/get-all-queues";

const RequestedAppointmentDropdown = () => {
  const showRequestedAptPopup = useQueueStore(
    (state) => state.showRequestedAptPopup
  );
  const setShowRequestedAptPopup = useQueueStore(
    (state) => state.setShowRequestedAptPopup
  );

  const { data: allQueueData } = useAllQueuesQuery();
  const requestedAppointments = allQueueData?.requestedAppointments || [];

  return requestedAppointments?.length ? (
    <Popover
      trigger={"click"}
      placement="rightTop"
      content={() => (
        <RequestedApppointmentsContent
          aptList={requestedAppointments || []}
          onClose={() => setShowRequestedAptPopup(false)}
        />
      )}
      overlayClassName="popover-p-0"
      open={showRequestedAptPopup}
      onOpenChange={(value) => setShowRequestedAptPopup(value)}
      destroyTooltipOnHide={true}
    >
      <RequestedAppointmentInfoUi
        count={requestedAppointments?.length || 0}
        onClick={() => setShowRequestedAptPopup(true)}
      />
    </Popover>
  ) : (
    <></>
  );
};

const RequestedApppointmentsContent = ({
  aptList,
  onClose,
}: {
  aptList: Appointment[];
  onClose: () => void;
}) => {
  return (
    <div className="dr-min-w-375 dr-bg-darwin-touch-neutral-50 dr-rounded-8">
      <div className="p-16 dr-bg-darwin-touch-neutral-0 dr-flex dr-flex-row dr-justify-between dr-items-center dr-rounded-t-8">
        <div className="Title3Regular">Requested Appointments</div>
        <XMarkRegularIcon
          className="dr-w-18 dr-h-18 dr-cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div className="dr-w-full dr-h-1 dr-bg-doctor-darwin-neutral-100" />
      <div className="dr-flex dr-flex-col dr-space-y-16 dr-p-16 dr-overflow-scroll dr-h-565">
        {aptList.map((apt) => {
          return (
            <LeftPanelCard
              aptData={apt}
              key={apt.aid}
              queueType={QUEUE_TYPE.REQUESTED}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RequestedAppointmentDropdown;
